// extracted by mini-css-extract-plugin
export default {"usersTable":"users-table_usersTable__+v6SV","sortIcons":"users-table_sortIcons__-EX-3"};